import sidebar from '@/config/sidebars/attribution'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AttributionSites = {
  index: async(props) => {
    const { default: SitesIndex } = await import('@/vue_widgets/attribution/sites/index.vue')
    createVueApp(SitesIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: SitesShow } = await import('@/vue_widgets/attribution/sites/show.vue')
    createVueApp(SitesShow, { props, sidebar })
  },
  new: async(props) => {
    const { default: SitesForm } = await import('@/vue_widgets/attribution/sites/form.vue')
    createVueApp(SitesForm, { props, sidebar })
  },
  edit: async(props) => {
    const { default: SitesForm } = await import('@/vue_widgets/attribution/sites/form.vue')
    createVueApp(SitesForm, { props, sidebar })
  }
}
